import { S3_PATH_DISPLAY_NAME } from "../constants/config";

export const redactPIData = (message: string): string => {

    const allowlistNumbers: string[] = import.meta.env.VITE_ALLOW_PHONE_NUMBERS
        ? import.meta.env.VITE_ALLOW_PHONE_NUMBERS.split(",").map((num: string) => num.trim())
        : [];

    const regexPatterns: { [key: string]: RegExp } = {
        "NRIC/FIN": /\b[SFTGM]\d{7}[A-Z]\b/gi,
        // FIN: /\b[FGM]\d{7}[A-Z]\b/gi,
        "PASSPORT": /\b[A-Z]\d{7}[A-Z]?\b/gi,
        "CONTACT_NO": /(?:(?:\+?65|0?65?)?\s?)?(?:[689])\d{3}\s?\d{4}\b/gi,
        "EMAIL": /\b(?![A-Za-z0-9._%+-]+@moe\.edu\.sg)[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}\b/gi
    };

    let redactedMessage = message;

    for (const key in regexPatterns) {
        if (key === "CONTACT_NO") {
            const matches = redactedMessage.match(regexPatterns[key]);
            if (matches) {
                matches.forEach((match) => {
                    if (!allowlistNumbers.includes(match)) {
                        console.log(match)
                        redactedMessage = redactedMessage.replace(match, "<CONTACT_NO>");
                    }
                });
            }
        } else {
            redactedMessage = redactedMessage.replace(regexPatterns[key], `<${key}>`);
        }
    }

    return redactedMessage;
};


export const trimWholeWordsPastLimit = (text: string, limit: number) => {
    if (text.length <= limit) {
        return text;
    }
    let trimmedText = text.slice(0, limit);
    let lastSpaceIndex = trimmedText.lastIndexOf(" ");
    if (lastSpaceIndex === -1) {
        return text.slice(0, limit - 3) + "...";
    }
    return trimmedText.slice(0, lastSpaceIndex) + "...";
}

export const capitalizeWords = (words: string) => {
    return words
    .split(' ')
    .map((word) => {
    if (word.length === 0) return ''; // Handle empty words if multiple spaces exist
    return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(' ');
  };
  
// export const joinedDisplayNamesByIndexes = (strItems: string[], indexes: number[]) => {
//     let result = ""
//     indexes.forEach((i) => {
//         if (i < 0 || strItems.length <= i) return 'Invalid index'

//         if (S3_PATH_DISPLAY_NAME[strItems[i]]) {
//             result += S3_PATH_DISPLAY_NAME[strItems[i]] + ' '
//         } else {
//             result += strItems[i] + ' '
//         }
//     })
//     return result.trim()
// }

export async function* handleStreamResponse(response: Response) {
    let buffer = ''
    const decoder = new TextDecoder('utf-8');
    if (response.body) {
        const reader = response.body.getReader();
        while (true) {
            const { done, value } = await reader.read();
            if (done) {
                console.log("Stream complete");
                break;
            }

            // // Process the chunk of data
            // buffer += decoder.decode(value, { stream: true });
            // // Process complete JSON objects
            // let startIndex = 0;
            // let endIndex;
            // let output = ''
            // while ((endIndex = buffer.indexOf('null}', startIndex)) !== -1) { //feedback comment always null for newly generated
            //     const jsonStr = buffer.slice(startIndex, endIndex + 1);
            //     output = jsonStr + 'ull}'
            //     startIndex = endIndex + 5;
            // }
            // // Keep the remaining incomplete data in the buffer

            // buffer = buffer.slice(startIndex);
            // yield output
            
            //Strands Specific
            // Add new data to buffer
            buffer += decoder.decode(value, { stream: true });
            
            // Look for complete JSON objects ending with }
            let lastIndex = 0;
            let braceCount = 0;
            
            for (let i = 0; i < buffer.length; i++) {
                if (buffer[i] === '{') {
                    braceCount++;
                } else if (buffer[i] === '}') {
                    braceCount--;
                    
                    // Found a complete JSON object
                    if (braceCount === 0) {
                        const jsonStr = buffer.slice(lastIndex, i + 1);
                        try {
                            JSON.parse(jsonStr); // Validate JSON
                            yield jsonStr;
                            lastIndex = i + 1;
                        } catch (e) {
                            console.error('Invalid JSON:', jsonStr);
                        }
                    }
                }
            }
            
            // Keep remaining incomplete data in buffer
            buffer = buffer.slice(lastIndex);
        }
    }
}

export const getScreenSize = () => {
    if (window.innerWidth < 768) return 1;
    if (window.innerWidth < 1024) return 2;
    return 3;
}